import { useEffect } from "react";
import { settingsStore } from "../features/settings/store";
import { applySettingsToDom } from "./applySettingsToDom";

export function useApplySettingsToDom() {
  useEffect(() => {
    const apply = () => applySettingsToDom(settingsStore.get());

    // initial
    apply();

    // settings changes
    const unsub = settingsStore.subscribe(() => apply());

    // system theme change (only if themeMode=system)
    const mql = window.matchMedia?.("(prefers-color-scheme: dark)");
    const onMql = () => {
      const s = settingsStore.get();
      if (s.themeMode === "system") applySettingsToDom(s);
    };

    mql?.addEventListener?.("change", onMql);

    return () => {
      unsub();
      mql?.removeEventListener?.("change", onMql);
    };
  }, []);
}
